import React from "react";

import  Box  from "@mui/material/Box";
import  Typography  from "@mui/material/Typography";

import  PreviousIcon from "./../../Assets/Icons/Previous.svg"

const AlternativeHeader=({title="",onPrevious})=>{
  return(
    <Box mt={2}>
      <Box display="flex" alignItems="center" gap={1.5}> 
        <img 
          onClick={onPrevious} 
          src={PreviousIcon} 
          alt={PreviousIcon} 
          style={{height:"30px", cursor: 'pointer'}} 
        />
      <Typography fontFamily="DM Sans" fontSize="22px" color="#D6B981">
        {title}
      </Typography>
      </Box>

    </Box>

  )
}
export default AlternativeHeader;